import { get, post } from "api/apiBridges/httpBridge";
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { modal_style } from "styles/modal_style"
import { Email, ExpandLess, ExpandMore } from "@mui/icons-material";
import { colors } from "styles/colors";
import {Typography, Avatar, Collapse, List, ListItemButton, ListItemText, Switch, Select, MenuItem, Dialog,} from "@mui/material";
import avatarTest from '../../images/others/avatar.png';
import { TextInput, CheckList, NumInput, TextFeature, SelectAdmin}  from "./LittleComponents";
import _ from "lodash";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import usePreventDoubleClick from "components/AntiDBC";
import { useLocalNotifications } from "components/Events";
import { ShowModal } from "components/Modal";
import Loading from 'components/Load';
import { PhoneInputGroup } from "utils/dndutils/PhoneInputGroup"; 

export default function Worker({data, onClose, setChanged}){
  
  const [$data, $setdata] = useState(data || {user: {}});
  const [login, setLogin] = useState(undefined);
  const [$roles, $setroles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [nodeType, setNodeType] = useState(data.type || "worker");
  const [nodeName, setNodeName] = useState(data.name || "");

  // Добавляем стейты для нового компонента телефона
  const [countryCode, setCountryCode] = useState('+7');
  const [number, setNumber] = useState('');

  const { company_id, rules } = useSelector(
    loginSelector
  );
  const preventDoubleClick = usePreventDoubleClick();

  const colorsmas = [
    '#fbef6d',
    '#c7d3ff',
    '#ffb3b7',
    '#fcc9ff',
    '#b7f6b9',
    '#b2f4e3',
    '#ffd7a4',
  ];

  const emailRegex = /^.+@.+\..{2,}$/;
  const { showNotification } = useLocalNotifications();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseData = await get('Roles/getCompanyRoles', {cid:company_id});
        let res = []
        if (responseData){
          responseData.map((el) => {
            res.push({id:el.id, title:el.title})
          })
        }
        $setroles(res);

        if ((rules.includes('company.show_login') || rules.includes("admin")) && data.id) {
          const meslogin = await get('auth/getLogin', {uid:data.user_id});
          if (meslogin.message) {
            setLogin(meslogin.message)
          }
        }

      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); 

  const setVal = (val, path) => {
    const currentValue = _.get($data, path);
    if (currentValue === val) return; 

    const newData = _.cloneDeep($data);
    _.set(newData, path, val);
    $setdata(newData);

    if (setChanged) setChanged(true); 
  }

  const handleNodeTypeChange = (val) => {
      if (nodeType === val) return;
      setNodeType(val);
      if (setChanged) setChanged(true);
  }
  const validateWorkerData = () => {
    if (nodeType !== "worker") {
        if (!nodeName.trim()) {
            showNotification({ id: 'noNodeName', type: 'error', message: 'Введите название отдела' });
            return false;
        }
        return true;
    }

    const fio = _.get($data, 'user.fio', '');
    const email = _.get($data, 'user.email', '');
    const role = _.get($data, 'role', '');
    const phoneDigitsLength = !$data.id 
      ? (countryCode + number).replace(/\D/g, '').length 
      : _.get($data, 'user.mobile_number', '').replace(/\D/g, '').length;

    if (!fio || fio.trim() === '') {
      showNotification({ id: 'noName', type: 'error', message: 'Не введено имя' });
      return false;
    }
    if (phoneDigitsLength < 11) {
      showNotification({ id: 'wrongNumber', type: 'error', message: 'Некорректный номер телефона' });
      return false;
    }
    if (!emailRegex.test(email)) {
      showNotification({ id: 'wrongEmail', type: 'error', message: 'Неправильно введена почта' });
      return false;
    }
    if (!role || role.trim() === '') {
      showNotification({ id: 'noName', type: 'error', message: 'Не введена должность' });
      return false;
    }
    return true;
  }

  const newClick = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateWorkerData()) return;

    try {
      const newStatus = `${data.parentStatus}_${data.childCount + 1}`;
      
      if (nodeType === "worker") {
        const digitsOnly = (countryCode + number).replace(/\D/g, '');
        const phoneWithPlus = '+' + digitsOnly;

        let obj = {
          userInfo: {
            fio: $data.user.fio,
            company_id,
            email: $data.user.email,
            mobile_number: phoneWithPlus,
            managers: 0,
            clients: 0,
            data: "",
            rules: $data.roles || [], 
          },
          authinfo: { login: phoneWithPlus },
          status: newStatus,
          role: $data.role,
          zp: $data.zp || 0, 
          oklad: $data.oklad || 0, 
          percent: $data.percent || 0,
          type: nodeType,
          color: $data.color
        };

        let check = await get("Registration/checkAuth", { login: obj.authinfo.login });
        if (check) {
          showNotification({ id: 'err', type: 'error', message: 'Номер уже занят' });
          return;
        }
        let resp = await post("Registration/addAdminMore", obj);
        if (data.set && resp.user_id && resp.cwid) {
          data.set({ ...obj, id: resp.cwid, user_id: resp.user_id, cwid: resp.cwid });
        }
      } 
      else {
        let resp = await post("companyWorkers/create", {
          status: newStatus,
          user_id: 0, 
          company_id: company_id,
          data: {
            name: nodeName,
            type: nodeType,
            color: $data.color
          }
        });

        if (data.set && resp?.message?.id) {
          data.set({           
            user_id: 0, 
            cwid: resp?.message?.id,
            company_id: company_id,
            name: nodeName,
            type: nodeType,
            color: $data.color,
            status: `${data.parentStatus}_${data.childCount+1}`,
          })
        }
      }

      showNotification({ id: 'ok', type: 'success', message: 'Добавлено успешно' });
      if (setChanged) setChanged(false);
      setTimeout(() => { onClose(true); }, 100);

    } catch (e) {
      console.error(e);
      showNotification({ id: 'errEx', type: 'error', message: 'Ошибка при сохранении' });
    }
  };

  const editClick = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    try {
      if (nodeType === "worker") {
        let obj = {
          role: $data.role,
          zp: $data.zp, 
          oklad: $data.oklad, 
          percent: $data.percent,
          type: nodeType,
          color: $data.color
        };
        await post("companyWorkers/update", { id: data.id, data: obj, roles: $data.roles, uid: data.user_id });
        if (data.set) data.set({ ...obj, id: data.id, status: data.status, roles: $data.roles, userInfo: $data.user });
      } 
      else {
        await post("companyWorkers/update", { id: data.id, data: { name: nodeName, type: nodeType, color: $data.color } });
        if (data.set) data.set({ id: data.id, name: nodeName, status: data.status, type: nodeType, color: $data.color });
      }

      showNotification({ id: 'editOk', type: 'success', message: 'Сохранено' });
      if (setChanged) setChanged(false);
      setTimeout(() => { onClose(true); }, 100);
    } catch (e) { console.error(e); }
  };
  
  const delWorker = () => {
    setOpen(true)
  }

  const delNode = async () => {
    ShowModal(
        'Удаление',
        <div>Вы уверены, что хотите удалить отдел?</div>,
        async () => {
            let updatedData = await post("companyWorkers/delNode", {status: data.status, company_id})
            data.set({
              updatedData,
              del: true
            })
            onClose(true)
        }
    );
  }

  const [activeColor, setActiveColor] = useState(null);

  if (loading) return (<Loading />);

  return (
  <div>
    <Dialog
      open={open}
      maxWidth='lg'
      PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
      onClose={() => { setOpen(false)}}
    >
      <div style={{ height: '650px', width: '300px', padding: '12px' }}>
        <RemoveWorker user_id={data.user_id} onClose={(updatedData) => {
          data.set({ updatedData, del: true });
          setOpen(false);
          onClose(true);
        }}/>
      </div>
    </Dialog>

    <div style={{ padding: '10px', display: "flex", flexDirection: "column"}}>
      <div style={{position:'absolute',alignItems: 'right', marginTop: '-55px', marginLeft:'380px' }}>

        {nodeType === "worker" && $data.id && (
          <Button 
            variant="contained" 
            onClick={preventDoubleClick(() => post("Registration/regenAdminPass", { user_id: data.user_id }).then(() => showNotification({ id: 'successRegenPass', type: 'success', message: 'Новый пароль отправлен' })), 1000)} 
            sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: '#078376' }}
          >
            Сгенерировать новый пароль
          </Button>
        )}
      </div>

      {!$data.id &&
        <div style={{ marginBottom: "10px", width: "60%" }}>
          <Typography variant="body1">Тип</Typography>
          <Select
            style={{ width: "100%", height: "30px" }}
            value={nodeType}
            onChange={(e) => handleNodeTypeChange(e.target.value)}
          >
            <MenuItem value={"worker"}>{"Сотрудник"}</MenuItem>
            <MenuItem value={"node"}>{"Отдел"}</MenuItem>
          </Select>
        </div>
      }

      {nodeType === "worker"?
        <div>
          
          <div style={{marginTop: "10px", width: "60%"}}>
            {$data.id && login && <TextFeature title="Логин" val={login} />}
          </div>

          <div style={{marginTop: "10px", width: "60%"}}>
            {$data.id ? <TextFeature title="ФИО" val={$data.user?.fio} /> : <TextInput title="ФИО" val={$data.user?.fio} onChange={(el) => setVal(el, "user.fio")} />}
          </div>

          <div style={{marginTop: "10px", width: "100%"}}> 
            {$data.id ?
              <TextFeature title="Телефон" val={($data.user?.mobile_number || '').replace(/\D/g, '')} />
              :
              <div style={{display:'flex', flexDirection:'column'}}>
                <Typography variant="body1" sx={{fontSize:'14px', marginBottom:'4px', color: "rgba(0, 0, 0, 0.6)"}}>Телефон</Typography>
                <PhoneInputGroup
                  countryCode={countryCode}
                  setCountryCode={setCountryCode}
                  number={number}
                  setNumber={setNumber}
                />
              </div>
            }
          </div>

          <div style={{marginTop: "10px", width: "60%"}}>
            {$data.id ? <TextFeature title="Почта" val={$data.user?.email} /> : <TextInput title="Почта" val={$data.user?.email} onChange={(el) => setVal(el, "user.email")} />}
          </div>

          <div style={{marginTop: "10px", width: "60%"}}>
            <TextInput title="Должность" val={$data.role} onChange={(el) => setVal(el, "role")} />
          </div>
          <div style={{marginTop: "10px", width: "60%"}}>
            <NumInput title="ЗП" val={$data.zp} onChange={(el) => setVal(el, "zp")} />
          </div>
          <div style={{marginTop: "10px", width: "60%"}}>
            <NumInput title="Оклад" val={$data.oklad} onChange={(el) => setVal(el, "oklad")} />
          </div>
          <div style={{marginTop: "10px", width: "60%"}}>
            <NumInput title="Проценты" val={$data.percent} onChange={(el) => setVal(el, "percent")} />
          </div>
          <div style={{marginTop: "10px", width: "60%"}}>
            <CheckList title={"Роль"} varlist={$roles} selected={$data.roles || []} onChange={(el) => setVal(el, "roles")} />
          </div>
        </div>
        :
        <div style={{marginTop: "10px", width: "60%"}}>
          <TextInput title="Название отдела" val={nodeName} onChange={(e) => { if (nodeName !== e) { setNodeName(e); if (setChanged) setChanged(true); } }} />
        </div>
      }

      <div style={{display:'flex', width:'60%', height:'60px', justifyContent:'space-between'}}>
        {colorsmas.map((el, index) => (
          <div
            key={index}
            onClick={() => { if ($data.color !== el) { setVal(el, "color"); setActiveColor(el); } }}
            style={{
              width:'25px', height:'25px', background:el, marginTop:'20px', borderRadius:'10px', cursor:'pointer',
              outline: ($data.color === el || activeColor === el) ? `3px solid ${el}` : 'none',
              outlineOffset: '2px'
            }}
          />
        ))}
      </div>

      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginTop: "30px", 
        paddingTop: "10px",
        borderTop: "1px solid #eee"
      }}>
        <div>
          {$data.id && $data.status !== '0' && (
            nodeType === "worker"?
              <Button variant="contained" onClick={preventDoubleClick(delWorker, 1000)} sx={{textTransform: 'none', fontWeight: 'bold', backgroundColor:'#078376'}}>Удалить сотрудника</Button>
              :
              <Button variant="contained" onClick={preventDoubleClick(delNode, 1000)} sx={{textTransform: 'none', fontWeight: 'bold', backgroundColor:'#078376'}}>Удалить отдел</Button>
          )}
        </div>

        <Button
          onClick={preventDoubleClick($data.id ? editClick : (e) => newClick(e), 1000)}
          variant="contained"
          sx={{ textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}
        >
          {$data.id ? "Сохранить" : "Добавить"}
        </Button>
      </div>
    </div>
  </div>
);
}

function RemoveWorker({user_id, onClose}) {
  const [newAdmin, setNewAdmin] = useState(undefined);
  const preventDoubleClick = usePreventDoubleClick();
  const save = async () => {
    if (newAdmin) {
      let updatedData = await post("companyWorkers/delWorker", {uid: user_id, nuid: newAdmin})
      onClose(updatedData)
    }
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "center"}}>
      <Typography variant="h6" style={{ marginBottom: '10px' }}>Удаление сотрудника</Typography>
      <div>
        <Typography variant="body1" style={{ marginBottom: '10px' }}>Кому перейдут клиенты:</Typography>
        <SelectAdmin user_id={user_id} onChange={setNewAdmin}/>
      </div>
      <Button 
        onClick={preventDoubleClick(save, 1000)} 
        variant="contained" 
        sx={{ marginTop: "20px", textTransform: 'none', backgroundColor: colors.elements, fontWeight: 'bold' }}
        disabled={!newAdmin}
      >
        Удалить сотрудника
      </Button>
    </div>
  )
}